import React, { useContext, useState, useRef, useEffect } from 'react';
import { WindowSizeContext } from '/src/App';
import PropertyNavigationDesktop from './Desktop/PropertyNavigationDesktop';
import PropertyNavigationMobile from './Mobile/PropertyNavigationMobile';
import NEWPropertyNavigationDesktop from './Desktop/NEWPropertyNavigationDesktop';
import GetPropertyExplorerNavTabs from '/src/services/Content/GetPropertyExplorerNavTabs';

const PropertyNavigation = ({ activeTab, setActiveTab, handleTabChange, isContentLoaded }) => {

    const { deviceType } = useContext(WindowSizeContext);
    const [hoveredTab, setHoveredTab] = useState(null);
    const [hoveredButton, setHoveredButton] = useState(null);
    const [isInDropdown, setIsInDropdown] = useState(false);
    const timeoutRef = useRef(null);
    const [lastTabHover, setLastTabHover] = useState(null);

    const tabs = GetPropertyExplorerNavTabs();
    const navTabsWithoutLastTab = tabs.slice(0, -1);

    const tabsToUse = activeTab === 'personalize' ? tabs : navTabsWithoutLastTab;


    const handleTabMouseEnter = (tabId) => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setLastTabHover(tabId);
        setHoveredTab(tabId);
    };

    const handleTabMouseLeave = () => {
        timeoutRef.current = setTimeout(() => {
            if (!isInDropdown) {
                setHoveredTab(null);
            }
        }, 150);
    };

    const handleDropdownMouseEnter = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        setIsInDropdown(true);
    };

    const handleDropdownMouseLeave = () => {
        setIsInDropdown(false);
        setHoveredTab(null);
    };

    useEffect(() => {
        if (isInDropdown && lastTabHover) {
            setHoveredTab(lastTabHover);
        }
    }, [isInDropdown, lastTabHover]);

    return (deviceType === 'desktop' || deviceType === 'tablet' || deviceType === 'mobile') ? (
        <NEWPropertyNavigationDesktop
            tabs={tabsToUse}
            activeTab={activeTab}
            hoveredTab={hoveredTab}
            hoveredButton={hoveredButton}
            handleTabChange={handleTabChange}
            handleTabMouseEnter={handleTabMouseEnter}
            handleTabMouseLeave={handleTabMouseLeave}
            handleDropdownMouseEnter={handleDropdownMouseEnter}
            handleDropdownMouseLeave={handleDropdownMouseLeave}
            setActiveTab={setActiveTab}
            setHoveredTab={setHoveredTab}
            setHoveredButton={setHoveredButton}
            setIsInDropdown={setIsInDropdown}
            isContentLoaded={isContentLoaded}
        />
        // <PropertyNavigationDesktop
        //     tabs={tabs}
        //     activeTab={activeTab}
        //     hoveredTab={hoveredTab}
        //     hoveredButton={hoveredButton}
        //     handleTabChange={handleTabChange}
        //     handleTabMouseEnter={handleTabMouseEnter}
        //     handleTabMouseLeave={handleTabMouseLeave}
        //     handleDropdownMouseEnter={handleDropdownMouseEnter}
        //     handleDropdownMouseLeave={handleDropdownMouseLeave}
        //     setActiveTab={setActiveTab}
        //     setHoveredTab={setHoveredTab}
        //     setHoveredButton={setHoveredButton}
        //     setIsInDropdown={setIsInDropdown}
        //     isContentLoaded={isContentLoaded}
        // />
    ) : (
        <PropertyNavigationMobile
            tabs={tabs}
            activeTab={activeTab}
            hoveredTab={hoveredTab}
            hoveredButton={hoveredButton}
            handleTabMouseEnter={handleTabMouseEnter}
            handleTabMouseLeave={handleTabMouseLeave}
            handleDropdownMouseEnter={handleDropdownMouseEnter}
            handleDropdownMouseLeave={handleDropdownMouseLeave}
            setActiveTab={setActiveTab}
            setHoveredTab={setHoveredTab}
            setHoveredButton={setHoveredButton}
            setIsInDropdown={setIsInDropdown}
            isContentLoaded={isContentLoaded}
        />
    );
};

export default PropertyNavigation;
